const CART_LINES_UPDATE_EVENT = 'shopify:cart:lines-update';
const SUCCESS_MESSAGE_DURATION = 2200;
const ERROR_MESSAGE_DURATION = 2200;

/** @type {WeakMap<HTMLButtonElement, { html: string, disabled: boolean, timeout: number | null }>} */
const buttonStates = new WeakMap();

/**
 * @param {HTMLButtonElement} button
 */
function getButtonState(button) {
  let state = buttonStates.get(button);

  if (!state) {
    state = {
      html: button.innerHTML,
      disabled: button.disabled,
      timeout: null,
    };
    buttonStates.set(button, state);
  }

  return state;
}

/**
 * @param {HTMLButtonElement} button
 */
function clearResetTimeout(button) {
  const state = getButtonState(button);
  if (state.timeout !== null) {
    window.clearTimeout(state.timeout);
    state.timeout = null;
  }
}

/**
 * @param {HTMLButtonElement} button
 */
function setLoading(button) {
  const state = getButtonState(button);
  clearResetTimeout(button);

  // Capture the current button markup again after any variant/card updates.
  if (!button.classList.contains('loka-quick-add-loading') && !button.classList.contains('loka-quick-add-success')) {
    state.html = button.innerHTML;
    state.disabled = button.disabled;
  }

  button.disabled = true;
  button.classList.remove('loka-quick-add-success', 'loka-quick-add-error');
  button.classList.add('loka-quick-add-loading');
  button.setAttribute('aria-busy', 'true');
  button.innerHTML = `
    <span class="loka-quick-add-feedback__content">
      <span class="loka-quick-add-feedback__spinner" aria-hidden="true"></span>
      <span>Añadiendo...</span>
    </span>
  `;
}

/**
 * @param {HTMLButtonElement} button
 * @param {boolean} success
 */
function showResult(button, success) {
  const state = getButtonState(button);
  clearResetTimeout(button);

  button.classList.remove('loka-quick-add-loading');
  button.classList.toggle('loka-quick-add-success', success);
  button.classList.toggle('loka-quick-add-error', !success);
  button.removeAttribute('aria-busy');
  button.disabled = true;
  button.innerHTML = `
    <span class="loka-quick-add-feedback__content">
      <span>${success ? 'Producto añadido!' : 'No se pudo añadir'}</span>
    </span>
  `;

  state.timeout = window.setTimeout(() => {
    button.innerHTML = state.html;
    button.classList.remove('loka-quick-add-success', 'loka-quick-add-error', 'loka-quick-add-loading');
    button.removeAttribute('aria-busy');
    button.disabled = state.disabled;
    state.timeout = null;
  }, success ? SUCCESS_MESSAGE_DURATION : ERROR_MESSAGE_DURATION);
}

/**
 * @param {Event} event
 */
function handleCartLinesUpdate(event) {
  if (!(event.target instanceof Element)) return;

  const productForm = event.target.closest('product-form-component');
  if (!productForm) return;

  const button = productForm.querySelector('button[data-quick-add-feedback="true"]');
  if (!(button instanceof HTMLButtonElement)) return;

  const promise = /** @type {Event & { promise?: Promise<any> }} */ (event).promise;
  if (!promise || typeof promise.then !== 'function') return;

  setLoading(button);

  promise
    .then(({ detail }) => {
      showResult(button, !detail?.didError);
    })
    .catch(() => {
      showResult(button, false);
    });
}

document.addEventListener(CART_LINES_UPDATE_EVENT, handleCartLinesUpdate);
